// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/cart/CartContents.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/cart/CartContents.tsx");
  import.meta.hot.lastModified = "1749484351006.3982";
}
// REMIX HMR END

import { Form, Link } from '@remix-run/react';
import { Price } from '~/components/products/Price';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
export function CartContents({
  orderLines,
  currencyCode,
  errors,
  formRef,
  onChangeInput,
  editable = true,
  adjustOrderLine,
  removeItem
}) {
  _s();
  const {
    t
  } = useTranslation();
  const [tempValue, setTempValue] = useState(orderLines.map(e => e.quantity));
  const isEditable = editable !== false;
  function handleChangeInput(e, line) {
    onChangeInput();
    adjustOrderLine && adjustOrderLine(line.id, +e.target.value);
  }
  return <div className="flow-root">
      <Form id="check-out-form" method="post" action="/" ref={formRef}>
        <ul role="list" className="-my-5 divide-y divide-gray-200">
          {(orderLines ?? []).map((line, orderIndex) => {
          const fieldName = `quantity-${line.id}`;
          return <li key={line.id} className="py-6 flex">
                <div className="flex-shrink-0 w-24 h-18 border border-grey1 rounded-md overflow-hidden">
                  <img src={line.featuredAsset?.preview + '?preset=thumb'} alt={line.productVariant.name} className="w-full h-full object-center object-cover w-24 h-18" />
                </div>
                <div className="ml-4 flex-1 flex flex-col">
                  <div>
                    <div className="flex justify-between text-base font-medium text-gray-900">
                      <h3>
                        <Link to={`/products/${line.productVariant.product.slug}`}>
                          {line.productVariant.name}
                        </Link>
                      </h3>
                      <p className="ml-4">
                        <Price priceWithTax={line.linePriceWithTax} currencyCode={currencyCode}></Price>
                      </p>
                    </div>
                  </div>
                  <div className="flex-1 flex items-center text-sm">
                    {editable ? <div className="flex flex-col">
                        <label htmlFor={`quantity-${line.id}`} className="mr-2">
                          {t('common.quantity')}
                        </label>
                        <input type="number" name={`quantity-${line.id}`} value={tempValue[orderIndex]} onChange={e => setTempValue(prevValues => {
                    const newValues = [...prevValues];
                    newValues[orderIndex] = parseInt(e.target.value);
                    return newValues;
                  })} onBlur={e => handleChangeInput(e, line)} className="max-w-full px-2 rounded-md border border-gray-300 py-1.5 text-base leading-5 font-medium text-gray-700 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm" />
                        {errors?.[fieldName] ? <em className="text-red-600">
                            {t('cart.errors.range')}
                          </em> : null}
                      </div> : <div className="text-gray-800">
                        <span className="mr-1">{t('common.quantity')}</span>
                        <span className="font-medium">{line.quantity}</span>
                      </div>}
                    <div className="flex-1"></div>
                    <div className="flex">
                      {isEditable && <button type="button" name="removeItem" value={line.id} className="font-medium text-primary-600 hover:text-primary-500" onClick={() => removeItem && removeItem(line.id)}>
                          {t('common.remove')}
                        </button>}
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ul>
        {errors?.sum ? <em className="text-red-600">{t('cart.errors.sum')}</em> : null}
      </Form>
    </div>;
}
_s(CartContents, "391RnF7NN7lIHG5C6C+VA2koI7o=", false, function () {
  return [useTranslation];
});
_c = CartContents;
var _c;
$RefreshReg$(_c, "CartContents");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;